var userToken: string = '';
var products: CDN.API.User.v1.LoginResultProduct[] = [];

var mapElement: HTMLElement = document.createElement('div');
var towers: GSMTowers;
CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.JQuery_UI, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.API_Vehicle_v1, },
    { code: CDN.PackageCode.API_Vehicle_Health_v1, },
    { code: CDN.PackageCode.API_Vehicle_Position_v1, },
    { code: CDN.PackageCode.API_GSM_v1, },
    { code: CDN.PackageCode.Map, },
    { code: CDN.PackageCode.MapTowers, },
    { code: CDN.PackageCode.Control_Login, },
	{ code: CDN.PackageCode.Control_UI_Button, },
	{ code: CDN.PackageCode.Bootstrap },
	{ code: CDN.PackageCode.Control_Dialog, },
	{ code: CDN.PackageCode.Control_UI_DropDown, },
	{ code: CDN.PackageCode.Control_UI_Input, },
], () => {
    /*Do our map code here:*/
    let parent = document.getElementsByTagName("body")[0];

    let loginDiv: HTMLElement = document.createElement('div');
    $(loginDiv).addClass('ms-3 p-2');
    parent.appendChild(loginDiv);

    let loaderElement: HTMLElement = document.createElement('div');
    $(loaderElement).addClass('row body-spinner-panel hide');
    parent.appendChild(loaderElement);

    let spinnerElement: HTMLElement = document.createElement('div');
    $(spinnerElement).addClass('body-spinner');
    loaderElement.appendChild(spinnerElement);

    let baseElement: HTMLElement = document.createElement('div');
    $(baseElement).addClass('d-flex d-none');
    parent.appendChild(baseElement);

    let dialogContainer: HTMLElement = document.createElement('div');
    $(dialogContainer).addClass('ps-2');
    $(dialogContainer).css('width', '250px');
    baseElement.appendChild(dialogContainer);

    $(mapElement).addClass('flex-grow-1 p-2');
    $(mapElement).css("height", "88vh");
    baseElement.appendChild(mapElement);

    if (sessionStorage.getItem('userToken') != null && sessionStorage.getItem('products') != null) {
        userToken = sessionStorage.getItem('userToken');
        products = JSON.parse(sessionStorage.getItem('products'));

        $(loginDiv).addClass('d-none');
        $(baseElement).removeClass('d-none');

        towers = new GSMTowers(mapElement, userToken, dialogContainer);
    } else {
        let login = new CDN.Controls.Login(loginDiv, {
            onError: (err) => {
                console.error(err);
            },
            onLogin: (result) => {
                if (result.UserToken == null) {
                    console.error('Invalid User Token');
                    return;
                }
                userToken = result.UserToken;
                for (let prod of result.products) {
                    products.push(prod);
                }
                sessionStorage.setItem('userToken', userToken);
                sessionStorage.setItem('products', JSON.stringify(products));

                login.hide();
                $(loginDiv).addClass('d-none');
                $(baseElement).removeClass('d-none');

                towers = new GSMTowers(mapElement, userToken, dialogContainer);
            }
        });
    }
});

class GSMTowers {
    private _parent: HTMLElement;
    private _parentDialogContainer: HTMLElement;
    private _dialogContainer: HTMLElement;
    private _filtersDialogContainer: HTMLElement;
    private _map: CDN.Map.Map;
    private _productList: CDN.Common.ProductId[] = [
        CDN.Common.ProductId.Protect,
        CDN.Common.ProductId.Approve,
        CDN.Common.ProductId.ApproveMU,
        CDN.Common.ProductId.Alert,
        CDN.Common.ProductId.Monitor,
        CDN.Common.ProductId.Supreme,
        CDN.Common.ProductId.SupremeMU,
        CDN.Common.ProductId.Assist,
        CDN.Common.ProductId.ApproveKE,
        CDN.Common.ProductId.SupremeKE,
        CDN.Common.ProductId.ApproveZM,
        CDN.Common.ProductId.SupremeZM,
    ];
    private _userToken: string;
    private _color: string = '#0089e3';
    private _highlightColor: string = '#3e8806';
    private _loadedFeatures: { [key: string]: CDN.Map.GeoJsonFeature } = {};
    private _openedDialogFeature: CDN.Map.GeoJsonFeature = null;
    private _towers: { [key: string]: CDN.Map.DataPoint } = {};
    private _filtersDialog: CDN.Controls.Dialog.Dialog = null;
    private _filteredVehicleId: string = null;
    private _collection: CDN.Map.FeatureCollection = new CDN.Map.FeatureCollection();
    private _sourceId: string;
    private _vehicles: { [key: string]: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } } = {};
    private _towerVehiclesCount: { [key: string]: number } = {};

    constructor(parent: HTMLElement, userToken: string, parentDialogContainer: HTMLElement) {
        this._parent = parent;
        this._parentDialogContainer = parentDialogContainer;
        /* prepare filters dialog container */
        this._filtersDialogContainer = document.createElement('div');
        $(this._parentDialogContainer).append(this._filtersDialogContainer);

        /* prepare dialog container */
        this._dialogContainer = document.createElement('div');
        $(this._parentDialogContainer).append(this._dialogContainer);

		this._userToken = userToken;
		let options: CDN.Map.MapOptions = {
			onMapStyleChangeAsync: async (style: CDN.Map.MapStyleOption) => {
				if (style == 'TomTomVector') {
					this._color = '#0089e3';
					this._highlightColor = '#3e8806';
				} else if (style == 'TomTomRaster') {
					this._color = '#ff5500';
					this._highlightColor = '#a52a2a';
				} else if (style == 'GoogleSatellite') {
					this._color = '#ffff23';
					this._highlightColor = '#37f3fd';
				}
				await this.loadAsync();
			},
			onLoad: async () => {
				this.showLoader();
				await this.loadVehicleDataAsync();
				await this.groupTowerVehiclesAsync();
				await this.loadAsync();
				return true;
			}
		}
		this.hideDialogContainer();
		this._map = new CDN.Map.Map(parent, options);
		this.showLoader();
	}

    public showLoader() {
        $('.body-spinner-panel').removeClass('hide');
        $('.body-spinner-panel .body-spinner').addClass('spinner-border text-secondary');
    }

    public hideLoader() {
        $('.body-spinner-panel').addClass('hide');
        $('.body-spinner-panel .body-spinner').removeClass('spinner-border text-secondary');
    }

    get dialogContainer() {
        return this._dialogContainer;
    }

    get filtersDialogContainer() {
        return this._filtersDialogContainer;
    }

    public resetDialogContainer() {
        $(this.dialogContainer).empty();
        this.showDialogContainer();
    }

    public showDialogContainer() {
        $(this.dialogContainer).removeClass('hide');
    }

    public hideDialogContainer() {
        $(this.dialogContainer).addClass('hide');
    }

	public async showAlertAsync(message: string, label?: string) {
		this.resetDialogContainer();
		let dialog: CDN.Controls.Dialog.MessageDialog = new CDN.Controls.Dialog.MessageDialog(this.dialogContainer, {
			title: label ?? 'Info',
			message: message,
			onClose: () => {
				this.hideDialogContainer();
			}
		});
		await dialog.OpenAsync();
	}

    public async loadVehicleDataAsync() {
        var vehTasks: Promise<{ productId: string, records: CDN.API.Vehicle.Health.v1.VehicleHealth[] }>[] = [];
        for (let i: number = 0; i < this._productList.length; i++) {
            /*Load all tower positions related to a product*/
            let productId: CDN.Common.ProductId = this._productList[i];
            vehTasks.push(CDN.API.Vehicle.Health.v1.GetVehiclesLastAsync({ productId: productId, userToken: this._userToken }, 7)
                .then((result: CDN.API.Vehicle.Health.v1.VehicleHealth[]) => {
                    return { productId: productId, records: result };
                }));
        }
        let results: { productId: string, records: CDN.API.Vehicle.Health.v1.VehicleHealth[] }[] = await Promise.all(vehTasks);
        for (let idx in results) {
            let row = results[idx];
            /* prepare class vehicles */
            for (let idx2 in row.records) {
                let vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth = row.records[idx2];
                this._vehicles[vehicleHealth.VehicleId] = { productId: row.productId, vehicleHealth: vehicleHealth };
            }
        }
    }

    public async loadAsync() {
        let towerResults: CDN.Map.DataPoint[][];
        let userToken: string = this._userToken;
        var posTasks: Promise<CDN.Map.DataPoint[]>[] = [];
        for (let i: number = 0; i < this._productList.length; i++) {
            /*Load all tower positions related to a product*/
            let productId: CDN.Common.ProductId = this._productList[i];
            posTasks.push(CDN.API.GSM.v1.GetAllGSMTowersAsync({ productId: productId, userToken: userToken })
                .then((result: CDN.API.GSM.v1.GSMTower[]) => {
                    /*Parse the results to Map.DataPoint type */
                    return this.parseTowersData(productId, result);
                }));
        }
        towerResults = await Promise.all(posTasks);
        /* check feature exists in the loaded features */
        let loadedFeatures: { [key: string]: CDN.Map.GeoJsonFeature } = { ...this._loadedFeatures };
        /* reset loaded features on class property */
        this._loadedFeatures = {};
        /* check and close the dialog - if any opened already */
        if (this._openedDialogFeature !== null && this._openedDialogFeature instanceof CDN.Map.GeoJsonFeature) {
            let oldFeature: CDN.Map.GeoJsonFeature = this._openedDialogFeature;
            oldFeature.properties.data.dialog.remove();
            oldFeature.properties.data.dialogVisible = false;
            oldFeature.properties.data.dialogInProgress = false;
        }
        /* reset openedDialog property */
        this._openedDialogFeature = null;

        this._towers = {};
        this._collection = new CDN.Map.FeatureCollection();
        this._sourceId = 'heatmap_towers_' + Math.floor(Math.random() * 100);
        for (let dataPoints of towerResults) {
            for (let dataPoint of dataPoints) {
                if (dataPoint.position.longitude == 0 || dataPoint.position.latitude == 0) {
                    continue;
                }
                let id: string = `${dataPoint.data.cellId}_${dataPoint.data.LAC}_${dataPoint.data.MCC}`;
                if (this._towers.hasOwnProperty(id)) {
                    /* tower exists already */
                    continue;
                }
                this._towers[id] = dataPoint;
                /* Since there were too much load in the towers map UI, at the initial stage - load the towers which has the vehicles count in the local data, 
                 * then when the users filtering the tower, add it to the collection one by one based on the request */
                if (!this._towerVehiclesCount.hasOwnProperty(id)) {
                    /* No vehicles available for the associated tower */
                    continue;
                }
                /* Create Point - GeoJsonFeature and add it to the FeatureCollection */
                let feature: CDN.Map.GeoJsonFeature = this.prepareFeature(id, dataPoint, this._collection, this._sourceId);
                this._collection.addFeature(feature);
                if (loadedFeatures.hasOwnProperty(id)) {
                    /* Replace the feature with the new one */
                    loadedFeatures[id] = feature;
                }
            }
        }
        this.hideLoader();
        this._map.clear();
        await this.showTowersAsync(this._sourceId, this._collection);
        this.showFiltersDialogAsync();
        if (Object.keys(loadedFeatures).length <= 0) {
            return;
        }
        /* loop through the loaded features */
        for (let featureId in loadedFeatures) {
            /* loadedFeatures */
            let feature: CDN.Map.GeoJsonFeature = loadedFeatures[featureId];
            await feature.properties.onClickAsync();
        }
    }

    public prepareFeature(id: string, dataPoint: CDN.Map.DataPoint, collection: CDN.Map.FeatureCollection, srcId: string, iconText?: string) {
        let feature: CDN.Map.GeoJsonFeature;
        let options: CDN.Map.FeatureOptions = {
            id: id,
            title: dataPoint.data?.title,
            position: [dataPoint.position.longitude, dataPoint.position.latitude],
            color: this._color,
            iconType: 'none',
            posType: '',
            onClickAsync: async () => {
                if (feature.properties.data?.isLoading && feature.properties.data.isLoading === true) {
                    return;
                }
                feature.properties.data.isLoading = true;
                if (!this._loadedFeatures.hasOwnProperty(id)) {
                    /* clear all selected */
                    await this.clearAllSelectedAsync(this._loadedFeatures, collection, srcId);
                    /* reset loaded features */
                    this._loadedFeatures = {};
                    /* highlight and load the vehicles */
                    this.selectTower(feature, collection, srcId);
                    /* load all recent vehicles associated with the towers */
                    let loadedVehiclesCount: number = await this.loadVehiclesAsync(feature);
                    await this.showTowerDialogAsync(feature, loadedVehiclesCount);
                    this._loadedFeatures[id] = feature;
                } else {
                    await this.clearVehiclesAsync(dataPoint);
                    this.deselectTower(feature, collection, srcId);
                    this._filteredVehicleId = null;
                    delete this._loadedFeatures[id];
                }
                feature.properties.data.isLoading = false;
                this._map.redraw();
            },
            data: {
                dataPoint: dataPoint
            }
        };
        if (iconText != null) {
            options.iconText = iconText;
        }
        /*Create Point - GeoJsonFeature and add it to the FeatureCollection */
        feature = new CDN.Map.GeoJsonFeature({ type: 'Point', coordinates: options.position }, options);
        feature.id = id;
        return feature;
    }

    public async showTowersAsync(srcId: string, collection: CDN.Map.FeatureCollection) {
        let source: CDN.Map.GeoJsonSource = new CDN.Map.GeoJsonSource(collection);
        /*Add heat map layer with the prepared source */
        let colorSet: string[] = [
            'rgba(162,212,231,0)',
            '#37afd3',
            '#a2d1e7',
            '#c8fdf8',
            '#7ccfff',
            '#1c8ad3'
        ];
        await this._map.addLayerAsync(source, new CDN.Map.HeatMapLayer(srcId + '_layer_heatmap', srcId, colorSet));
        /* Add symbol layer with the same source */
        let layerId: string = srcId + '_layer_tower';
        await this._map.addLayerAsync(source, new CDN.Map.SymbolLayer(layerId, srcId, { iconimage: 'tower', iconsize: 0.3, radiusType: 'fixed', opacity: 1, overlap: true, textColor: '#004b8b', textSize: 12, textBottom: true }));
        this._map.setCenter(4);
    }

    public selectTower(feature: CDN.Map.GeoJsonFeature, collection: CDN.Map.FeatureCollection, srcId: string) {
        feature.properties.iconType = 'highlight';
        feature.properties.color = this._highlightColor;
        let mapSource: maplibregl.GeoJSONSource = this._map.core.getSource(srcId) as maplibregl.GeoJSONSource;
        mapSource.setData(collection);
        let zoom: number = this._map.core.getZoom();
        if (zoom <= 8) {
            zoom = 12;
        }
        this._map.setCenter(zoom, null, feature.properties.coordinates);
    }

    public deselectTower(feature: CDN.Map.GeoJsonFeature, collection: CDN.Map.FeatureCollection, srcId: string) {
        feature.properties.iconType = 'none';
        feature.properties.color = this._color;
        delete feature.properties.iconText;
        /* clear tower dialog if exists */
        if (feature.properties.data?.dialogVisible && feature.properties.data.dialogVisible === true) {
            if (feature.properties.data?.dialog && feature.properties.data.dialog instanceof CDN.Controls.Dialog.Dialog) {
                feature.properties.data.dialog.remove();
                feature.properties.data.dialogVisible = false;
            }
        }
        let mapSource: maplibregl.GeoJSONSource = this._map.core.getSource(srcId) as maplibregl.GeoJSONSource;
        mapSource.setData(collection);
    }

	public async showTowerDialogAsync(feature: CDN.Map.GeoJsonFeature, count: number) {
		let dataPoint: CDN.Map.DataPoint = feature.properties.data.dataPoint;
		this.resetDialogContainer();
		let div: HTMLElement = document.createElement('div');
		div.innerHTML = `CellID: <b>${dataPoint.data.cellId}</b><br/>
				    LAC: <b>${dataPoint.data.LAC}</b><br/>
					MCC: <b>${dataPoint.data.MCC}</b><br/>
					Vehicles Count: <b>${count}</b><br/>`;
		let dialog: CDN.Controls.Dialog.MessageDialog = new CDN.Controls.Dialog.MessageDialog(this.dialogContainer, {
			title: 'Tower Details',
			message: div,
			onClose: () => {
				this.hideDialogContainer();
			}
		});
		await dialog.OpenAsync();
		feature.properties.data.dialog = dialog;
		feature.properties.data.dialogVisible = true;
		/* update it in the opened dialog */
		this._openedDialogFeature = feature;
	}

    public async clearAllSelectedAsync(features: { [key: string]: CDN.Map.GeoJsonFeature }, collection: CDN.Map.FeatureCollection, srcId: string) {
        /* loop through all the features */
        for (let featureId in features) {
            let feature: CDN.Map.GeoJsonFeature = features[featureId];
            /* clear vehicles */
            if (feature.properties.data?.dataPoint) {
                await this.clearVehiclesAsync(feature.properties.data.dataPoint);
            }
            /* remove highlight */
            this.deselectTower(feature, collection, srcId);
        }
    }

    /* vehicles */
    public selectVehicle(feature: CDN.Map.GeoJsonFeature, collection: CDN.Map.FeatureCollection, srcId: string) {
        feature.properties.radius = 7;
        feature.properties.color = '#1ab888';
        let mapSource: maplibregl.GeoJSONSource = this._map.core.getSource(srcId) as maplibregl.GeoJSONSource;
        mapSource.setData(collection);
        let zoom: number = this._map.core.getZoom();
        if (zoom <= 8) {
            zoom = 12;
        }
        this._map.setCenter(zoom, null, feature.properties.coordinates);
    }

    public deselectVehicle(feature: CDN.Map.GeoJsonFeature, collection: CDN.Map.FeatureCollection, srcId: string) {
        feature.properties.radius = 5;
        feature.properties.color = '#ff3b00';
        delete feature.properties.iconText;
        /* clear tower dialog if exists */
        if (feature.properties.data?.dialogVisible && feature.properties.data.dialogVisible === true) {
            if (feature.properties.data?.dialog && feature.properties.data.dialog instanceof CDN.Controls.Dialog.Dialog) {
                feature.properties.data.dialog.remove();
                feature.properties.data.dialogVisible = false;
            }
        }
        let mapSource: maplibregl.GeoJSONSource = this._map.core.getSource(srcId) as maplibregl.GeoJSONSource;
        mapSource.setData(collection);
    }

    public async loadVehiclesAsync(feature: CDN.Map.GeoJsonFeature): Promise<number> {
        let dataPoint: CDN.Map.DataPoint = feature.properties.data.dataPoint;
        let towerVehicles: { [key: string]: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } } = await this.getTowerVehiclesAsync(
            dataPoint.data.cellId,
            dataPoint.data.LAC,
            dataPoint.data.MCC
        );
        if (Object.keys(towerVehicles).length == 0) {
            return 0;
        }
        this.showLoader();
        /* get position of these vehicles based on it's DateTime */
        var vehiclePositionTasks: Promise<CDN.API.Vehicle.Position.v1.Position>[] = [];
        for (let vehId in towerVehicles) {
            let vehicle = <{ productId: CDN.Common.ProductId, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth }>towerVehicles[vehId];
            vehiclePositionTasks.push(CDN.API.Vehicle.Position.v1.GetByVehicleIdDateTimeAsync({ productId: vehicle.productId, userToken: this._userToken },
                { vehicleId: vehicle.vehicleHealth.VehicleId, dateTime: vehicle.vehicleHealth.DateTime })
                .then((position: CDN.API.Vehicle.Position.v1.Position) => {
                    return position;
                }));
        }
        let results: CDN.API.Vehicle.Position.v1.Position[] = await Promise.all(vehiclePositionTasks);
        let towerVehiclePositions: { [key: string]: CDN.API.Vehicle.Position.v1.Position } = {};
        for (let key in results) {
            let position: CDN.API.Vehicle.Position.v1.Position = results[key];
            if (position == null) {
                continue;
            }
            towerVehiclePositions[position.VehicleId] = position;
        }
        this.hideLoader();
        let filteredOption: CDN.Map.FeatureOptions = null;
        let collection: CDN.Map.FeatureCollection = new CDN.Map.FeatureCollection();
        let srcId: string = 'tower_vehicles_' + dataPoint.data.id;
        for (let vehicleId in towerVehicles) {
            let vehicle = <{ productId: CDN.Common.ProductId, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth }>towerVehicles[vehicleId];
            if (!towerVehiclePositions.hasOwnProperty(vehicleId)) {
                continue;
            }
            let position: CDN.API.Vehicle.Position.v1.Position = towerVehiclePositions[vehicleId];
            let featureId: string = 'vehicle_' + vehicleId;
            let feature: CDN.Map.GeoJsonFeature;
            let option: CDN.Map.FeatureOptions = {
                id: featureId,
                title: vehicleId,
                position: [position.Longitude, position.Latitude],
                dataType: '',
                data: {
                    vehilcleID: vehicleId
                },
                color: '#ff3b00',
                lineColor: '#ff3b00',
                radius: 5,
				onClickAsync: async () => {
					/* check and close the dialog - if any opened already */
					if (this._openedDialogFeature != null && this._openedDialogFeature instanceof CDN.Map.GeoJsonFeature) {
						let oldFeature: CDN.Map.GeoJsonFeature = this._openedDialogFeature;
						if (oldFeature.properties.data.dialog instanceof CDN.Controls.Dialog.Dialog) {
							oldFeature.properties.data.dialog.hide();
						}
						oldFeature.properties.data.dialogVisible = false;
						oldFeature.properties.data.dialogInProgress = false;
						/* de-select the vehicle */
						this.deselectVehicle(this._openedDialogFeature, collection, srcId);
						/* check the opened dialog related to this feature */
						this._filteredVehicleId = null;
						if (this._openedDialogFeature.id == feature.id) {
							/* current feature dialog is closed - return */
							this._openedDialogFeature = null;
							return;
						}
					}
					/* reset property */
					this._openedDialogFeature = null;
					if (feature.properties.data?.dialogInProgress && feature.properties.data.dialogInProgress === true) {
						/* dialog processing */
						return;
					}
					feature.properties.data.dialogInProgress = true;
					let dialog: CDN.Controls.Dialog.MessageDialog;
					try {
						/* prepare dialog params */
						let date: Date = new Date(vehicle.vehicleHealth.DateTime);
						/* Get Vehicle Information */
						this.showLoader();
						let health: CDN.API.Vehicle.Health.v1.Health = await CDN.API.Vehicle.Health.v1.GetLastAsync({ productId: vehicle.productId, userToken: this._userToken }, vehicle.vehicleHealth.VehicleId, date);
						this.hideLoader();
						this.resetDialogContainer();
						let div: HTMLElement = document.createElement('div');
						div.innerHTML = `Registration: <b>${vehicle.vehicleHealth.Registration}</b><br/>
										Serial: <b>${vehicle.vehicleHealth.Serial}</b><br/>
										DateTime: <b>${health.DateTime.toLocaleString()}</b><br/>
										Sys DateTime: <b>${health.SystemDateTime.toLocaleString()}</b><br/>
										Ver Major: <b>${health.VerMajor}</b><br/>
										Ver Minor: <b>${health.VerMinor}</b><br/>
										Ver Release: <b>${health.VerRelease}</b><br/>
										Ver Build: <b>${health.VerBuild}</b><br/>
										GPS FIX: <b>${health.GPSFix}</b><br/>
										GPS HDOP: <b>${health.GPSHDOP}</b><br/>
										Batt Voltage: <b>${health.BattVoltage}</b><br/>
										Input Voltage: <b>${health.InputVoltage}</b><br/>
										GSM Signal: <b>${health.GSMSignal}</b><br/>
										GSM State: <b>${health.GSMState}</b><br/>
										GSM Tower: <b>${health.GSMTower}</b><br/>
										LAC: <b>${health.LAC}</b><br/>
										MCC: <b>${health.GSMMCC}</b><br/>
										GPS Count: <b>${health.GPSCount}</b><br/>
										Mem Count: <b>${health.MemCount}</b><br/>`;
						dialog = new CDN.Controls.Dialog.MessageDialog(this.dialogContainer, {
							title: 'Vehicle Details',
							message: div,
							buttonText: 'Close',
							onClose: () => {
								feature.properties.data.dialogVisible = false;
								this._openedDialogFeature = null;
								this.hideDialogContainer();
								/* de-select the vehicle */
								this.deselectVehicle(feature, collection, srcId);
								this._filteredVehicleId = null;
							}
						});
						await dialog.OpenAsync();
					} catch (e) {
						feature.properties.data.dialogVisible = false;
						feature.properties.data.dialogInProgress = false;
						return;
					}
					/* select the vehicle */
					this.selectVehicle(feature, collection, srcId);
					feature.properties.data.dialog = dialog;
					feature.properties.data.dialogVisible = true;
					feature.properties.data.dialogInProgress = false;
					/* update it in the opened dialog */
					this._openedDialogFeature = feature;
				}
            };
            /* create circle layer for all the vehicles */
            feature = new CDN.Map.GeoJsonFeature({ type: 'Point', coordinates: option.position }, option);
            feature.id = featureId;
            collection.addFeature(feature);
            if (this._filteredVehicleId != null && this._filteredVehicleId == vehicleId) {
                filteredOption = option;
            }
        }
        let source = new CDN.Map.GeoJsonSource(collection);
        await this._map.addLayerAsync(source, new CDN.Map.CircleLayer(srcId + '_circle_layer', srcId));
        if (filteredOption != null) {
            /* select the vehicle and load the health record of that vehicle */
            await filteredOption.onClickAsync();
        }
        return Object.keys(towerVehiclePositions).length;
    }

    public async clearVehiclesAsync(dataPoint: CDN.Map.DataPoint) {
        let srcId: string = 'tower_vehicles_' + dataPoint.data.id;
        let source: CDN.Map.GeoJsonSource = this._map.getSource(srcId);
        if (source == undefined || source == null) {
            return;
        }
        if (source.data instanceof CDN.Map.FeatureCollection) {
            /* loop through all the features in the featurecollection */
            let features: CDN.Map.GeoJsonFeature[] = source.data.getFeatures();
            for (let feature of features) {
                /* Clear the dialog */
                if (feature.properties.data?.dialogVisible && feature.properties.data.dialogVisible === true) {
                    if (feature.properties.data?.dialog && feature.properties.data.dialog instanceof CDN.Controls.Dialog.Dialog) {
                        feature.properties.data.dialog.remove();
                        feature.properties.data.dialogVisible = false;
                    }
                }
            }
        }
        this._map.removeSource(srcId);
    }

    public parseTowersData(productId: string, rawData: CDN.API.GSM.v1.GSMTower[]): CDN.Map.DataPoint[] {
        /*Convert all VehiclePosition results to Map.DataPoint */
        let responseData: CDN.Map.DataPoint[] = [];
        for (let tower of rawData) {
            let point: CDN.Map.DataPoint = {
                position: {
                    longitude: tower.Lon,
                    latitude: tower.Lat
                },
                data: {
                    id: tower.Id,
                    title: tower.Name,
                    cellId: tower.CellId,
                    LAC: tower.LAC,
                    MCC: tower.MCC,
                    productId: productId,
                    vehicleId: null
                }
            };
            responseData.push(point);
        }
        return responseData;
    }

	public async showFiltersDialogAsync() {
		if (this._filtersDialog != null) {
			this._filtersDialog.hide();
		}
		$(this.filtersDialogContainer).empty();
		let controlElement: HTMLElement = document.createElement('div');
		let towerInputsElement: HTMLElement = document.createElement('div');
		let vehicleInputsElement: HTMLElement = document.createElement('div');
		let filterLabel: HTMLLabelElement = document.createElement('label');
		filterLabel.innerHTML = 'Filter By';
		$(controlElement).append(filterLabel);

		/* set filter by dropdown */
		let filterByDropDown = new CDN.Controls.UI.DropDown.DropDown(controlElement, {
			options: [
				{ value: 'tower', name: 'Tower' },
				{ value: 'vehicle', name: 'Vehicle' }
			],
			onSelect: (item, itemBefore) => {
				let filterType: string = filterByDropDown.Value.value;
				if (filterType == 'tower') {
					/* disable vehicle inputs, enable tower inputs */
					$(vehicleInputsElement).addClass('hide');
					$(towerInputsElement).removeClass('hide');
				} else if (filterType == 'vehicle') {
					/* disable tower inputs, enable vehicle inputs */
					$(vehicleInputsElement).removeClass('hide');
					$(towerInputsElement).addClass('hide');
				}
			}
		});

		$(controlElement).append(vehicleInputsElement);
		$(controlElement).append(towerInputsElement);
		$(vehicleInputsElement).addClass('hide');

		let regLabel: HTMLLabelElement = document.createElement('label');
		regLabel.innerHTML = 'Vehicle Registration';
		$(vehicleInputsElement).append(regLabel);

		let regInput: CDN.Controls.UI.TextInput<CDN.API.Vehicle.Health.v1.VehicleHealth> = new CDN.Controls.UI.TextInput(vehicleInputsElement, {
			placeholder: 'Vehicle Registration',
			autocomplete: {
				minLength: 3,
				searchAsync: async (term) => {
					let responseData: { label: string, value: string, data: CDN.API.Vehicle.Health.v1.VehicleHealth }[] = [];
					for (let vehId in this._vehicles) {
						let vehicle: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } = this._vehicles[vehId];
						if (vehicle.vehicleHealth.Registration.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
							/* has search term */
							responseData.push({
								label: vehicle.vehicleHealth.Registration,
								value: vehicle.vehicleHealth.Registration,
								data: vehicle.vehicleHealth
							});
						}
					}
					return responseData;
				},
				onSelect: async (result: CDN.API.Vehicle.Health.v1.VehicleHealth) => {
					let vehicleId: string = result.VehicleId.toString();
					await this.filterVehicleTowersAsync(vehicleId);
					return true;
				}
			}
		});
		//$(regInput).addClass('hide');

		let cellLabel: HTMLLabelElement = document.createElement('label');
		cellLabel.innerHTML = 'Cell ID';
		$(towerInputsElement).append(cellLabel);

		let cellInput: CDN.Controls.UI.TextInput = new CDN.Controls.UI.TextInput(towerInputsElement, {
			placeholder: 'Cell ID'
		});

		let lacLabel: HTMLLabelElement = document.createElement('label');
		lacLabel.innerHTML = 'LAC';
		$(towerInputsElement).append(lacLabel);

		let lacInput: CDN.Controls.UI.TextInput = new CDN.Controls.UI.TextInput(towerInputsElement, {
			placeholder: 'LAC'
		});

		let mccLabel: HTMLLabelElement = document.createElement('label');
		mccLabel.innerHTML = 'MCC';
		$(towerInputsElement).append(mccLabel);

		let mccInput: CDN.Controls.UI.TextInput = new CDN.Controls.UI.TextInput(towerInputsElement, {
			placeholder: 'MCC'
		});

		let dialog: CDN.Controls.Dialog.Dialog = new CDN.Controls.Dialog.Dialog(this.filtersDialogContainer, {
			title: 'Search Options',
			content: controlElement,
			buttons: [new CDN.Controls.Dialog.Button(controlElement, {
				text: 'Search',
				afterSelectionAsync: async () => {
					let filterType: 'tower' | 'vehicle' = filterByDropDown.Value.value;
					if (filterType == 'tower') {
						await this.filterTowerAsync(cellInput, lacInput, mccInput);
					} else if (filterType == 'vehicle') {
						let vehicleId: string = regInput.value;
						if (vehicleId == undefined) {
							this.showAlertAsync('Invalid Registration.', 'Filter By Vehicle');
							return;
						}
						let value: string = regInput.value;
						if (value == '') {
							this.showAlertAsync('Invalid Registration.', 'Filter By Vehicle');
							return;
						}
						this.showLoader();
						await this.filterVehicleTowersAsync(vehicleId);
						this.hideLoader();
					}
				}
			})]
		});

		await dialog.OpenAsync();
		this._filtersDialog = dialog;
		setTimeout(() => {
			$(vehicleInputsElement).parent().addClass('hide');
		}, 100);
	}

    public async filterVehicleTowersAsync(vehicleId: string) {
        let vehicle: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } = this._vehicles[vehicleId];
        let health: CDN.API.Vehicle.Health.v1.VehicleHealth = vehicle.vehicleHealth;

        let towers: { [key: string]: CDN.Map.DataPoint } = { ...this._towers };
        let towerId: string = `${health.GSMTower}_${health.LAC}_${health.GSMMCC}`;
        if (!towers.hasOwnProperty(towerId)) {
			this.showAlertAsync('No towers found for the selected vehicle.', 'No Towers');
            return;
        }
        let feature: CDN.Map.GeoJsonFeature = this._collection.getFeature(towerId);
        if (feature == null) {
            let dataPoint: CDN.Map.DataPoint = towers[towerId];
            feature = this.prepareFeature(towerId, dataPoint, this._collection, this._sourceId);
            this._collection.addFeature(feature);
        }
        /* clear all selected */
        await this.clearAllSelectedAsync(this._loadedFeatures, this._collection, this._sourceId);
        /* reset loaded features */
        this._loadedFeatures = {};
        this.selectTower(feature, this._collection, this._sourceId);
        this._loadedFeatures[feature.id] = feature;
        this._filteredVehicleId = vehicleId;
        this._openedDialogFeature = null;
        await this.loadVehiclesAsync(feature);
    }

    public async getTowerVehiclesAsync(cellId: number, LAC: number, MCC: number) {
        let towerVehicles: { [key: string]: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } } = {};
        let vehicles: { [key: string]: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } } = { ...this._vehicles };
        for (let vehId in vehicles) {
            let vehicle: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } = this._vehicles[vehId];
            if (vehicle.vehicleHealth.GSMTower == cellId && vehicle.vehicleHealth.LAC == LAC && vehicle.vehicleHealth.GSMMCC == MCC) {
                /* vehicle matches */
                towerVehicles[vehId] = vehicle;
            }
        }
        return towerVehicles;
    }

    public async groupTowerVehiclesAsync() {
        this._towerVehiclesCount = {};
        let vehicles: { [key: string]: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } } = { ...this._vehicles };
        for (let vehId in vehicles) {
            let vehicle: { productId: string, vehicleHealth: CDN.API.Vehicle.Health.v1.VehicleHealth } = this._vehicles[vehId];
            let id: string = `${vehicle.vehicleHealth.GSMTower}_${vehicle.vehicleHealth.LAC}_${vehicle.vehicleHealth.GSMMCC}`;
            if (!this._towerVehiclesCount.hasOwnProperty(id)) {
                this._towerVehiclesCount[id] = 0;
            }
            this._towerVehiclesCount[id]++;
        }
    }

	public async filterTowerAsync(cellInput: CDN.Controls.UI.TextInput, lacInput: CDN.Controls.UI.TextInput, mccInput: CDN.Controls.UI.TextInput) {
		let cellId: string = cellInput.value;
		let lac: string = lacInput.value;
		let mcc: string = mccInput.value;
		if (cellId == '') {
			cellInput.focus();
			this.showAlertAsync('Cell ID is empty.', 'Filter By Tower');
			return;
		} else if (lac == '') {
			lacInput.focus();
			this.showAlertAsync('LAC is empty.', 'Filter By Tower');
			return;
		} else if (mcc == '') {
			mccInput.focus();
			this.showAlertAsync('MCC is empty.', 'Filter By Tower');
			return;
		}
		let towers: { [key: string]: CDN.Map.DataPoint } = { ...this._towers };
		let towerId: string = `${cellId}_${lac}_${mcc}`;
		if (!towers.hasOwnProperty(towerId)) {
			this.showAlertAsync('No towers found with the given data.', 'Filter By Tower');
			return;
		}

		let feature: CDN.Map.GeoJsonFeature = this._collection.getFeature(towerId);
		if (feature == null) {
			/* tower feature not exists in the collection - create one */
			let dataPoint: CDN.Map.DataPoint = towers[towerId];
			feature = this.prepareFeature(towerId, dataPoint, this._collection, this._sourceId,);
			this._collection.addFeature(feature);
		}
		/* clear all selected */
		await this.clearAllSelectedAsync(this._loadedFeatures, this._collection, this._sourceId);
		/* reset loaded features */
		this._loadedFeatures = {};
		this.selectTower(feature, this._collection, this._sourceId);
		this._loadedFeatures[feature.id] = feature;
		this._filteredVehicleId = null;
		let loadedVehiclesCount: number = await this.loadVehiclesAsync(feature);
		await this.showTowerDialogAsync(feature, loadedVehiclesCount);
	}
}
